<template>
    <div class="create-visit-form__textarea">
        <label class="show-for-sr" :for="field.id">{{ field.label }}</label>
        <textarea :id="field.id" :placeholder="field.label" :required="field.required" :name="field.name" rows="5"></textarea>
    </div>
</template>

<script>
export default {
    name: 'TextAreaField',
    props: ['field'],
}
</script>